import { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';
import * as validation from '../../../utils/validation';

import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';

class ModalContactAddOrUpdateInternal extends Component {
    state = {
        contactId: "",
        name: "",
        mobilePhoneNumber: "",
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\"";
        
        this.nameValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        this.setState(
            {
                contactId: isUpdate ? this.props.contactToUpdate.contactId : "",
                name: isUpdate ? this.props.contactToUpdate.name : "",
                mobilePhoneNumber: isUpdate ? `+${this.props.contactToUpdate.mobilePhoneNumber}` : "",
            }
        );
    }

    handleDoneButtonClicked = () => {
        const trimmedDescription = this.state.name.trim();
        const trimmedMobilePhoneNumber = this.state.mobilePhoneNumber.trim().substring(1); // Remove the leading + from the mobile phone number.

        const doneInfo = {
            contactId: this.state.contactId,
            name: trimmedDescription,
            mobilePhoneNumber: trimmedMobilePhoneNumber,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleCancelButtonClicked = () => {
        this.props.onHide();
    }

    handleNameChanged = (e) => {
        const updatedName = e.target.value;

        if (updatedName.length > 0 && !this.nameValidationRegex.test(updatedName)) {
            return;
        }
                
        this.setState({
            name: updatedName
        });
    }

    handleMobilePhoneNumberChanged = (e) => {
        if (e.target.value.length > 0 && !validation.isPartialE164PhoneNumber(e.target.value)) {
            return;
        }
                
        this.setState({
            mobilePhoneNumber: e.target.value
        });
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.name === '') {
            return "Name may not be empty";
        }

        if (this.state.name.length > 50) {
            return "Name must be less than 50 characters";
        }

        if (this.state.mobilePhoneNumber === '') {
            return "Mobile phone number may not be empty";
        }

        if (!validation.isE164PhoneNumber(this.state.mobilePhoneNumber)) {
            return "Mobile phone number must be a valid E.164 phone number";
        }

        if (this.state.name !== this.props.contactToUpdate.name ||
            this.state.mobilePhoneNumber !== this.props.contactToUpdate.mobilePhoneNumber) { 
                return null;
        }

        return "No changes detected";
    }

    render() {
        const headerText = this.props.isUpdate ? 'Update Contact' : 'Add Contact';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newContactName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" value={this.state.name} autoComplete="off" onChange={this.handleNameChanged} />
                    </Form.Group>
                    <Form.Group controlId="newContactMobilePhoneNumber">
                        <Form.Label>Mobile Phone Number</Form.Label>
                        <Form.Control type="text" placeholder="Enter mobile phone number" value={this.state.mobilePhoneNumber} autoComplete="off" onChange={this.handleMobilePhoneNumberChanged} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalContactAddOrUpdate = (props) => {
    return (
        <ModalContactAddOrUpdateInternal {...props}/>
    )
}